"use client";

import { Box, Center, Flex, Skeleton } from "@chakra-ui/react";
import { useSnapshot } from "valtio";

import { state } from "@/app/state";

export function NoRecSelected({ isLoading }: { isLoading: boolean }) {
  const authSnap = useSnapshot(state.auth);
  return (
    <Box w="100%" h="100%" bgImage="/heart1.png" bgSize="cover" position="relative" bgPos="center">
      <Box position="absolute" top={8} left={8} color="white">
        <Box fontSize="4xl" fontWeight="200">
          {new Date().toLocaleDateString("en-US", {
            weekday: "long",
            month: "short",
            day: "numeric",
          })}
        </Box>
        <Box fontSize="2xl" fontWeight="bold">
          👈 Today's recommendations for{" "}
          {authSnap.backend.user?.firstName?.trim().replace(/[^\w\s]$/, "")}
        </Box>
      </Box>

      <Center h="90%" flexDir="column">
        {isLoading ? (
          <Flex fontWeight="bold" color="theme.label.light" mt={4}>
            <Skeleton fontSize="2xl" mt={4}>
              Loading Indicator
            </Skeleton>
          </Flex>
        ) : (
          <></>
        )}
      </Center>
    </Box>
  );
}
